export default function Hero() {
  return (
    <section id="home" className="relative min-h-screen flex flex-col justify-center overflow-hidden">
      {/* Background with subtle zoom */}
      <div className="absolute inset-0 img-zoom">
        <img
          src="https://readdy.ai/api/search-image?query=premium%20eco%20friendly%20gated%20community%20villa%20plots%20near%20Sarjapur%20Road%20Bangalore%2C%20wide%20roads%20with%20trees%2C%20lush%20green%20residential%20layout%2C%20aerial%20view%20of%20residential%20plots%20with%20greenery%2C%20modern%20gated%20community%20Bangalore%2C%20peaceful%20residential%20area%20with%20palm%20trees%20and%20open%20sky%2C%20golden%20hour%20lighting&width=1920&height=1080&seq=ui-hero-main-01&orientation=landscape"
          alt="Premium villa plots on Sarjapur Road Bangalore - Urban Infra"
          className="w-full h-full object-cover object-top hero-bg-zoom"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-[#1B2A4A]/90 via-[#1B2A4A]/75 to-[#1B2A4A]/60"></div>
      </div>

      {/* Green accent line at top */}
      <div className="absolute top-0 left-0 right-0 h-1 bg-[#7FBF3F] z-10"></div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-8 pt-24 pb-20">
        <div className="max-w-3xl">
          {/* Badge */}
          <div className="hero-animate-1 inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 text-[#7FBF3F] text-xs font-semibold uppercase tracking-widest px-4 py-2 rounded-full mb-6">
            <i className="ri-map-pin-line"></i>
            Bengaluru&apos;s Trusted Real Estate Developer Since 2016
          </div>

          <h1 className="hero-animate-2 text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-5" style={{ fontFamily: "'Playfair Display', serif" }}>
            Premium Villa Plots On Sarjapur Road, Bangalore
          </h1>

          <p className="hero-animate-3 text-white/80 text-base md:text-lg leading-relaxed mb-4 max-w-2xl" style={{ fontFamily: "'Poppins', sans-serif" }}>
            Eco-friendly gated community layouts on Sarjapur Road, designed for modern living and smart investment.
          </p>

          {/* Urgency */}
          <div className="hero-animate-3 inline-flex items-center gap-2 bg-[#F36F21]/90 text-white text-xs font-bold px-4 py-2 rounded-full mb-8">
            <i className="ri-alarm-warning-line"></i>
            Limited Plots Available — Act Now
          </div>

          {/* CTAs */}
          <div className="hero-animate-4 flex flex-col sm:flex-row gap-4 mb-12">
            <a
              href="#contact"
              className="btn-hover inline-flex items-center justify-center gap-2 bg-[#7FBF3F] hover:bg-[#6aaa32] text-white font-bold px-8 py-4 rounded-xl cursor-pointer whitespace-nowrap text-base cta-pulse"
            >
              <i className="ri-calendar-check-line"></i>
              Book Now
            </a>
            <a
              href="https://wa.me/919945124133?text=Hi%2C%20I%27m%20interested%20in%20your%20plots%20near%20Sarjapur%20Road.%20Please%20share%20details."
              target="_blank"
              rel="nofollow noreferrer"
              className="btn-hover inline-flex items-center justify-center gap-2 bg-white/10 hover:bg-white/20 border border-white/40 text-white font-bold px-8 py-4 rounded-xl cursor-pointer whitespace-nowrap text-base backdrop-blur-sm"
            >
              <i className="ri-whatsapp-line text-[#7FBF3F]"></i>
              Get Details on WhatsApp
            </a>
          </div>

          {/* Trust Chips */}
          <div className="hero-animate-5 flex flex-wrap gap-3">
            {[
              { icon: "ri-award-line", text: "Since 2016" },
              { icon: "ri-building-2-line", text: "7+ Completed Projects" },
              { icon: "ri-map-pin-2-line", text: "On Sarjapur Road" },
              { icon: "ri-shield-check-line", text: "Premium Location" },
            ].map((item) => (
              <div key={item.text} className="flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 text-white text-xs font-medium px-4 py-2 rounded-full">
                <i className={`${item.icon} text-[#7FBF3F]`}></i>
                {item.text}
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-1 text-white/50 text-xs animate-bounce">
        <span>Scroll</span>
        <i className="ri-arrow-down-line"></i>
      </div>
    </section>
  );
}
